<div class="bonus-panel">
    <img *ngIf="bonusPanelImage" [src]="bonusPanelImage" (click)="showActionSheet()" />
</div>
